import styled from 'styled-components';
import { StyledProductThumbnailProps } from './types';

export const StyledProductThumbnail = styled.div<StyledProductThumbnailProps>`
  display: block;
  width: ${({ isBig }) => (isBig ? '5rem' : '3.125rem')};
  height: ${({ isBig }) => (isBig ? '5rem' : '3.125rem')};
  border-radius: var(--r-md);
  overflow: hidden;
`;

export const StyledProductImage = styled.img`
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
`;

export const StyledProductThumbnailEmpty = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--paper-2);
  color: rgba(9, 15, 56, 0.4);
  svg {
    width: 44%;
    height: 44%;
    max-width: 1.75rem;
    max-height: 1.75rem;
    opacity: 0.55;
  }
`;
